import React from 'react';

import { Wrapper,Image, Content, StyledLink} from "./Display.styles";
import { Link } from "react-router-dom";



const Display = ({
    employee,
    group,
    dept,
    title,
    givname,
    surname,
    adr1,
    adr2,
    adr3,
    pcode,
    phone,
    sdate,
    baserate,
    holrule,
    sicrule,
    holavail,
    leaveDates,
    termdate,
    position,
    identity,
    incometax,
    dob,
    active,
    normalHours,
    gender,
    race,
    disability,
    foreignNational,
    injuryOnDuty,
    IDOnFile,
    emailaddress,
    edit
    
}) => (

    <div>
        

        <Wrapper>
        {!edit?(<Content><div>Code:</div>{employee}</Content>):(<Content><div>Code:</div><input placeholder={employee} /></Content>)}
        <Content><div>Name:</div>{givname}</Content>
        <Content><div>Surname:</div>{surname}</Content>
        <Content><div>Tel nr:</div>{phone}</Content>
        <Content><div>Group:</div>{group}</Content>
        <Content><div>Dept:</div>{dept}</Content>
        <Content><div>Title:</div>{title}</Content>
        <Content><div>Adres1:</div>{adr1}</Content>
        <Content><div>Adres2:</div>{adr2}</Content>
        <Content><div>Adres3:</div>{adr3}</Content>
        <Content><div>Postal code:</div>{pcode}</Content>
        
        <Content><div>Start Date</div>{sdate}</Content>
        <Content><div>Rate</div>{baserate}</Content>
        <Content><div>Holiday rule</div>{holrule}</Content>
        <Content><div>Sick leave</div>{sicrule}</Content>
        <Content><div>Holiday Available</div>{holavail}</Content>
        <Content><div>Leave Dates</div>{leaveDates}</Content>
        <Content><div>Termination date</div>{termdate}</Content>
        <Content><div>Position</div>{position}</Content>
        <Content><div>ID nr</div>{identity}</Content>
        <Content><div>Income tax nr:</div>{incometax}</Content>
        <Content><div>Birthday:</div>{dob}</Content>
        <Content><div>Active</div>{active}</Content>
        <Content><div>Normal Hours</div>{normalHours}</Content>
        <Content><div>Gender</div>{gender}</Content>
        <Content><div>Race</div>{race}</Content>
        <Content><div>Disability</div>{disability}</Content>
        <Content><div>Foreign National</div>{foreignNational}</Content>
        <Content><div>IOD</div>{injuryOnDuty}</Content>
        <Content><div>ID on file:</div>{IDOnFile}</Content>
        <Content><div>Email:</div>{emailaddress}</Content>

        
       </Wrapper>
        
        
    </div>

);


    
export default Display;
